import React from 'react'
import PropTypes from 'prop-types'
import { identity } from 'lodash-es'
import { Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { connect } from 'react-redux'
import { returnToOrigin, goToCancelUri } from 'utils/navigate'
import { getActionName } from 'utils/content'
import { logToServer } from 'utils/logger'
import * as fpti from 'utils/fpti'
import { isNewFlowModal, isPayrollPartnerVariantOrIntent } from 'utils/flow'
import { resetUnexpectedClientError } from '@/features/ui/ui-slice'
import IconPage from 'components/common/IconPage'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'
import { unexpectedErrorContentCss } from './styles'

let fptiPage = '@action:unexpectedError'
const fptiSummaryBtn = 'summaryBtn'
const { unexpectedErrorTags } = COMMON_FPTI_TAGS

class UnexpectedError extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    error: PropTypes.object,
    actionType: PropTypes.string,
    actionName: PropTypes.string,
  }

  UNSAFE_componentWillMount() {
    // actionName is currently passed by new flow modal
    this.actionName = this.props.actionName || getActionName(this.props.actionType)
    fptiPage = fptiPage.replace('@action', this.actionName)
    fpti.startCPLTracking(fptiPage)
  }

  componentDidMount() {
    const { error } = this.props
    const { page, ...rest } = unexpectedErrorTags(this.actionName, 'ac')
    fpti.logActivity(page, rest)
    fpti.recordImpression(fptiPage, {
      errorMessage: error?.message,
      errorType: 'UnexpectedJSError',
      errorDescription: error?.stack,
      ...rest
    })
    fpti.endCPLTracking()

    // Unexpected error triggered during dispatch
    // Currently only used in new flow modal, error set in ui.unexpectedError state
    if (error) {
      logToServer('UnexpectedError triggered', {
        actionName: this.actionName,
        message: error.message || '',
        stack: error.stack || '',
        href: window.location.href,
        userAgent: navigator.userAgent,
      })
    }
  }

  componentWillUnmount() {
    if (isNewFlowModal()) {
      this.props.dispatch(resetUnexpectedClientError())
    }
  }

  handleOnDone = () => {
    fpti.recordClick(fptiPage, fptiSummaryBtn, unexpectedErrorTags(this.actionName, 'cl'))

    if (isPayrollPartnerVariantOrIntent()) {
      goToCancelUri()
      return
    }

    returnToOrigin(this.props.dispatch, { endFlow: true })
  }

  render() {
    return (
      <IconPage
        data-testid="unexpected-error-page"
        headerId="error.unexpectedError.header"
        contentId="error.unexpectedError.content"
        wrapWithModalContent
        contentCss={unexpectedErrorContentCss}
      >
        <Button data-testid="unexpected-error-done-button" onClick={this.handleOnDone}>
          <Message id="common.button.done" />
        </Button>
      </IconPage>
    )
  }
}

const stateProps = ({ card }) => {
  const { actionType } = card.fetchError || {}
  return { actionType }
}

const actionProps = {
  dispatch: identity,
}

export default connect(stateProps, actionProps)(UnexpectedError)
